module.exports = __webpack_public_path__ + "img/logo.0b4f3fd0.png";